// ja — checkin/quickCheck/stepTracker blocks translated.
export const ja = {
  "common": {
    "loading": "読み込み中...",
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "削除",
    "edit": "編集",
    "close": "閉じる",
    "confirm": "確認",
    "back": "戻る",
    "next": "次へ",
    "submit": "送信",
    "search": "検索",
    "select": "選択",
    "or": "または",
    "and": "および",
    "note": "メモ",
    "viewAll": "すべて表示",
    "learnMore": "詳細を見る",
    "getStarted": "はじめる",
    "continue": "続ける",
    "saving": "保存中…"
  },
  "nav": {
    "dashboard": "ホーム",
    "nutrition": "栄養管理",
    "family": "ファミリー",
    "care": "サービス",
    "careShort": "サービス",
    "checkIn": "チェックイン",
    "insights": "インサイト",
    "trends": "トレンド",
    "habits": "習慣",
    "medications": "お薬管理",
    "expertSupport": "エキスパート相談",
    "profile": "プロフィール",
    "healthHub": "ヘルスハブ",
    "support": "サポート",
    "wellness": "ウェルネス",
    "education": "学習コンテンツ",
    "community": "コミュニティ",
    "preventiveHealth": "予防医学",
    "womensHealth": "ウィメンズヘルス",
    "reminders": "健康リマインダー",
    "meals": "食事",
    "orders": "注文履歴",
    "subscription": "サブスクリプション",
    "logout": "ログアウト"
  },

  "navShort": {
    "dashboard": "ホーム",
    "nutrition": "栄養",
    "family": "家族",
    "care": "サービス",
    "support": "サポート",
    "profile": "プロフィール"
  },
  "auth": {
    "login": "サインイン",
    "register": "アカウント作成",
    "logout": "サインアウト",
    "email": "メールアドレス",
    "password": "パスワード",
    "name": "氏名",
    "forgotPassword": "パスワードをお忘れですか？",
    "noAccount": "アカウントをお持ちでない場合",
    "haveAccount": "すでにアカウントをお持ちの場合",
    "signInHere": "こちらからサインイン",
    "signUpHere": "こちらから新規登録",
    "welcomeBack": "おかえりなさい！",
    "getStarted": "はじめましょう",
    "biometricLogin": "生体認証でサインイン",
    "biometricHelper": "指紋、顔認証、またはWindows Helloを使用",
    "vendorLogin": "ベンダーログイン",
    "createOne": "新規作成",
    "tagline": "毎日の簡単なチェックで、一歩先の健康管理を。",
    "takes30s": "30秒ほどで完了します",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "パスワードを入力してください",
    "checking": "確認中…",
    "continue": "続ける",
    "secureMessage": "安全でプライベート。お客様のデータは厳重に保護されます",
    "biometricSoon": "生体認証ログイン — 近日公開",
    "sessionExpired": "セッションの期限が切れました。続きから始めるには、もう一度サインインしてください。",
    "showPassword": "パスワードを表示",
    "hidePassword": "パスワードを非表示",
    "vendor": {
      "title": "ベンダーパートナー・ログイン",
      "subtitle": "HealthLoop ベンダーダッシュボードへアクセス",
      "businessEmail": "ビジネス用メールアドレス",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "サインイン中...",
      "signIn": "サインイン",
      "notVendorYet": "まだベンダーパートナーではありませんか？",
      "registerBusiness": "ビジネスを登録する",
      "areYouUser": "一般ユーザーの方はこちら",
      "userLogin": "ユーザーログイン",
      "welcomeBackToast": "おかえりなさい！",
      "genericError": "ログインに失敗しました。もう一度お試しください。"
    },
    "admin": {
      "backToUserLogin": "ユーザーサインインへ",
      "title": "管理者サインイン",
      "restrictedBadge": "制限あり",
      "tagline": "HealthLoop オペレーターコンソール — 管理者権限が必要です。",
      "emailLabel": "管理者メールアドレス",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "パスワード",
      "passwordPlaceholder": "管理者パスワードを入力",
      "signingIn": "サインイン中...",
      "submit": "コンソールにサインイン",
      "secureNote": "安全な接続 · セッションは暗号化されています",
      "restrictedTitle": "このエリアは管理者専用です。",
      "restrictedBody": "現在のアカウントでサインインしていますが、管理者権限がありません。別のアカウントでサインインし直すか、メインアプリにお戻りください。",
      "signOut": "サインアウト",
      "backToApp": "アプリに戻る"
    }
  },
  "quickCheck": {
    "header": {
      "title": "今日の調子はいかがですか？",
      "subtitle": "クイックチェック - 60秒以内に終わります"
    },
    "section1": {
      "title": "今、何か気になることはありますか？",
      "hint": "（あてはまるものをすべて選択）"
    },
    "environment": {
      "title": "今日の周囲の環境",
      "hint": "あなたの周りの状況を教えてください"
    },
    "basicChecks": {
      "title": "簡単な基本チェック",
      "hint": "任意ですが、入力するとより詳しい分析ができます"
    },
    "validation": {
      "pickOne": "少なくとも1つの質問にお答えください"
    },
    "submit": {
      "cta": "健康インサイトを受け取る",
      "saving": "保存中...",
      "analyzing": "健康パターンを分析中...",
      "savedToast": "✅ 保存しました！健康パターンを分析しています..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "歩数トラッカー",
      "subtitle": "日々の活動を大切に記録します",
      "backToDashboard": "ダッシュボードに戻る"
    },
    "today": {
      "title": "今日の歩数",
      "goalProgress": "{{current}} / {{goal}} 歩",
      "goalReached": "目標達成です！素晴らしいですね！",
      "keepGoing": "その調子です。順調に進んでいますよ。"
    },
    "streak": {
      "label": "現在の継続期間",
      "days": "{{count}}日",
      "daysPlural": "{{count}}日間"
    },
    "badges": {
      "title": "バッジ",
      "empty": "習慣が身についてくると、バッジを獲得できます。"
    },
    "reminders": {
      "title": "お散歩の通知",
      "hint": "座りっぱなしのときに、軽く動くための優しいリマインドをお送りします。",
      "enabled": "オン",
      "disabled": "オフ"
    },
    "insights": {
      "weeklyAverage": "週平均",
      "weeklyGoal": "週の目標"
    },
    "actions": {
      "connect": "歩数データと連携する",
      "manualLog": "手動で記録する",
      "changeGoal": "目標歩数を変更する"
    }
  },
  "checkin": {
    "header": {
      "title": "今日の体調チェックイン",
      "subtitle": "60秒ほどで完了します",
      "restDayLink": "今日はそんな気分じゃない"
    },
    "snapshot": {
      "title": "最新のダッシュボード",
      "healthScore": "健康スコア",
      "todayTasks": "今日のタスク",
      "dayStreak": "継続日数"
    },
    "resume": {
      "banner": "前回の続きから再開しました",
      "startFresh": "最初から始める",
      "dismiss": "閉じる"
    },
    "progress": {
      "allSet": "準備完了",
      "step": "ステップ {{current}} / {{total}}",
      "ariaLabel": "今日のチェックイン進捗：{{total}}セクション中 {{done}}セクション完了"
    },
    "insights": {
      "title": "あなたの健康インサイト",
      "subtitle": "今日のあなたに合わせたアドバイス",
      "insightForYou": "あなたへのインサイト",
      "simpleActions": "すぐにできる簡単なアクション",
      "whenToSeekHelp": "専門家に相談する目安",
      "nhsAdvice": "気になる症状がある場合は、かかりつけ医や相談窓口へご連絡ください",
      "backToDashboard": "ダッシュボードに戻る",
      "newCheckIn": "新しいチェックイン",
      "disclaimer": "HealthLoopは、医療診断ではなくウェルネスガイダンスを提供します。"
    },
    "restDay": {
      "title": "休息もリズムのひとつです。",
      "body": "あなたの準備が整ったとき、いつでもここでお待ちしています。",
      "streakNote": "記録は途切れません。記録も一緒に一休みしているだけです。",
      "backToDashboard": "ダッシュボードに戻る",
      "changedMind": "やっぱりチェックインする"
    },
    "feelings": {
      "title": "今日の気分や体調はいかがですか？",
      "hint": "あてはまるものをすべて選択してください",
      "tired": "疲れを感じる",
      "headache": "頭痛がする",
      "stressed": "ストレスや負担を感じる",
      "pain": "体の痛みやコリがある",
      "okay": "今日はいい感じ"
    },
    "basics": {
      "title": "基本のセルフケア",
      "sleepQ": "昨夜はよく眠れましたか？",
      "waterQ": "今日は水分を十分に摂れていますか？",
      "foodQ": "今日はしっかり食事を摂りましたか？",
      "activityQ": "今日はどのくらい体を動かしましたか？",
      "yes": "はい",
      "notReally": "あまり",
      "notYet": "まだこれから",
      "notActive": "動いていない",
      "lightActivity": "軽い運動",
      "active": "活発に動いた"
    },
    "mind": {
      "title": "こころとエネルギー",
      "stressQ": "今のストレスレベルはどのくらいですか？",
      "moodQ": "今の気分はいかがですか？",
      "energyQ": "今のエネルギーレベルはいかがですか？",
      "low": "低い",
      "moderate": "普通",
      "high": "高い",
      "neutral": "どちらでもない",
      "good": "良い",
      "okay": "まあまあ"
    },
    "day": {
      "title": "今日の一日",
      "routineQ": "今日はいつものルーティン通りに過ごせましたか？",
      "yes": "はい",
      "no": "いいえ"
    },
    "environment": {
      "title": "今日の周囲の環境",
      "describeQ": "今の環境はどのような感じですか？",
      "comfortable": "😊 快適",
      "slightlyUncomfortable": "😐 少し落ち着かない",
      "challenging": "😓 過ごしにくい",
      "affectedQ": "周囲の環境は気分に影響しましたか？",
      "yes": "はい",
      "no": "いいえ",
      "exposureLabel": "気になったこと（複数選択可）",
      "heat": "🌡️ 暑さ",
      "cold": "❄️ 寒さ",
      "noise": "🔊 騒音",
      "dustSmoke": "💨 ほこり・煙",
      "crowded": "👥 混雑",
      "none": "✅ 特になし"
    },
    "submit": {
      "analyzing": "健康パターンを分析中...",
      "cta": "健康インサイトを見る"
    },
    "toast": {
      "savedFull": "チェックインを保存しました。ダッシュボードを更新しました。",
      "savedShort": "チェックインを保存しました。"
    }
  },
  "onboarding": {
    "welcome": "ようこそ",
    "completeSetup": "セットアップを完了する",
    "stepProgress": "ステップ {{step}} / {{total}}",
    "percentComplete": "{{percent}}% 完了",
    "welcomeToast": "HealthLoopへようこそ！プロフィールの設定が完了しました。",
    "errorAgeRange": "年齢層を選択してください",
    "errorCountry": "お住まいの国を選択してください",
    "errorGoal": "主な健康目標を選択してください",
    "errorCuisine": "お好みの料理を少なくとも1つ選択してください",
    "errorGeneric": "設定を完了できませんでした。もう一度お試しください。",
    "step1Title": "HealthLoopへようこそ！ 👋",
    "step1Subtitle": "あなたにぴったりの健康習慣を提案します",
    "ageRangeLabel": "年齢層を教えてください",
    "genderLabel": "性別（任意）",
    "gender_male": "男性",
    "gender_female": "女性",
    "gender_non-binary": "ノンバイナリー",
    "gender_prefer_not_to_say": "回答しない",
    "step2Title": "お住まいの地域はどちらですか？ 🌍",
    "step2Subtitle": "食文化に合わせた食事の提案に活用します",
    "countryLabel": "国を選択してください",
    "country_uk": "イギリス",
    "country_nigeria": "ナイジェリア",
    "country_ghana": "ガーナ",
    "country_kenya": "ケニア",
    "country_south_africa": "南アフリカ",
    "country_usa": "アメリカ合衆国",
    "country_canada": "カナダ",
    "country_india": "インド",
    "country_jamaica": "ジャマイカ",
    "country_other": "その他",
    "step3Title": "主な目標は何ですか？ 🎯",
    "step3Subtitle": "最も重視する健康の目的を選んでください",
    "additionalGoals": "その他の目標はありますか？（任意）",
    "goal_weight_loss": "減量",
    "goalDesc_weight_loss": "健康的に体重を落とす",
    "goal_weight_maintenance": "体重維持",
    "goalDesc_weight_maintenance": "現在の体重をキープする",
    "goal_muscle_gain": "筋力アップ",
    "goalDesc_muscle_gain": "筋力と筋肉量を増やす",
    "goal_general_wellness": "総合的な健康維持",
    "goalDesc_general_wellness": "全体的な体調を整える",
    "goal_better_sleep": "睡眠の質向上",
    "goalDesc_better_sleep": "ぐっすり眠れるようにする",
    "goal_reduce_stress": "ストレス軽減",
    "goalDesc_reduce_stress": "ストレスを上手に管理する",
    "goal_increase_energy": "活力アップ",
    "goalDesc_increase_energy": "毎日をより元気に過ごす",
    "step4Title": "食事の好み 🍽️",
    "step4Subtitle": "お好みの料理や食事制限について教えてください",
    "cuisineLabel": "好みの料理",
    "cuisineHint": "1つ以上選択してください（複数選択可）",
    "dietaryLabel": "食事制限（任意）",
    "diet_vegetarian": "ベジタリアン",
    "diet_vegan": "ヴィーガン",
    "diet_halal": "ハラール",
    "diet_kosher": "コーシャ",
    "diet_gluten_free": "グルテンフリー",
    "diet_dairy_free": "乳製品フリー",
    "diet_pescatarian": "ペスカタリアン",
    "step5Title": "健康状態について 🏥",
    "step5Subtitle": "任意です。より適切なアドバイスを提供するために活用します",
    "conditionsLabel": "現在、以下の症状や持病はありますか？",
    "conditionsHint": "この情報は非公開で、あなたに合わせたウェルネスガイダンスのためにのみ使用されます",
    "condition_diabetes": "糖尿病",
    "condition_hypertension": "高血圧",
    "condition_heart_disease": "心臓疾患",
    "condition_thyroid": "甲状腺疾患",
    "condition_celiac": "セリアック病",
    "condition_ibs": "過敏性腸症候群 (IBS)",
    "condition_none": "特になし",
    "privacyTitle": "お客様のデータは守られています",
    "privacyBody": "個人情報は暗号化され、安全に保管されます。これらのデータは、あなたにぴったりの献立提案、健康アドバイス、通知のパーソナライズにのみ使用されます。お客様の明示的な同意なしに、第三者に共有されることはありません。",
    "trackMedication": "お薬の管理を利用する",
    "specialistInterest": "専門家への相談に興味がある",
    "welcomeTitle": "HealthLoopへようこそ！ 👋",
    "welcomeSubtitle": "いくつかの簡単なステップで、あなた専用のAI予防ヘルス＆ライフスタイル・インテリジェンスを設定しましょう",
    "stepLabel": "ステップ {{current}} / {{total}}",
    "skipForNow": "今はスキップする",
    "skipToast": "プロフィールからいつでもオンボーディングを完了できます",
    "back": "戻る",
    "next": "次へ",
    "completing": "完了しています...",
    "complete": "設定を完了する",
    "successToast": "HealthLoopへようこそ！プロフィールがパーソナライズされました 🎉",
    "failureToast": "オンボーディングの完了に失敗しました",
    "validation": {
      "basicInfo": "基本情報をすべて入力してください",
      "pickGoal": "健康の目標を少なくとも1つ選択してください",
      "pickPrimary": "最も優先する目標を選択してください",
      "pickRegion": "食事のおすすめをパーソナライズするため、文化圏を選択してください",
      "pickFocus": "主なウェルネス・フォーカスを選択してください"
    },
    "step1": {
      "title": "あなたの健康プロフィール",
      "description": "あなた専用のAI健康インテリジェンスを作成するお手伝いをさせてください",
      "age": "年齢 *",
      "agePlaceholder": "例: 30",
      "height": "身長 (cm) *",
      "heightPlaceholder": "例: 170",
      "weight": "体重 (kg) *",
      "weightPlaceholder": "例: 70"
    },
    "step2": {
      "title": "健康の目標",
      "description": "当てはまるものをすべて選択し、その中から最も優先する目標を1つ選んでください",
      "primaryLabel": "最も優先する目標を選択 *",
      "primaryBadge": "最優先"
    },
    "step3": {
      "title": "🌍 食文化の好み",
      "description": "お食事のおすすめをあなた好みに合わせましょう",
      "regionLabel": "文化圏 *",
      "regionHint": "パーソナライズされたお食事の提案のため、あなたの文化的な背景を選択してください",
      "countryLabel": "国（任意）",
      "countryPlaceholder": "例: 日本、ナイジェリア、ジャマイカ",
      "countryHint": "より細かなおすすめのために活用します",
      "foodPrefLabel": "食事の多様性の好み"
    },
    "step4": {
      "title": "主なウェルネス・フォーカス",
      "description": "最も注力したい分野を選んでください"
    },
    "step5": {
      "title": "あなたの設定",
      "description": "HealthLoopの体験をカスタマイズしましょう",
      "trackMeds": "お薬の記録",
      "trackMedsHint": "毎日のチェックインで、お薬の記録とリマインダーを有効にします",
      "specialist": "専門家サポートに興味がある",
      "specialistHint": "ウェルネス専門家、栄養士、メンタルヘルスのプロへのアクセスが可能になります",
      "confidentialTitle": "機密性の保持:",
      "confidentialBody": "すべての情報は保護され、パーソナライズされた予防的健康インサイトを提供するためだけに利用されます。"
    },
    "step6": {
      "title": "食事のパーソナライズ",
      "description": "あなたの味の好みや食事のニーズに合ったメニューをおすすめします",
      "cuisinesLabel": "お好みの料理（任意）",
      "cuisinesHint": "よく食べる料理、好きな料理を選択してください",
      "dietaryLabel": "食事制限（任意）",
      "dietaryHint": "当てはまるものを選択してください",
      "allergiesLabel": "一般的なアレルギー（任意）",
      "allergiesHint": "食物アレルギーがあれば選択してください",
      "personalisedTitle": "パーソナライズされた食事:",
      "personalisedBody": "これらの設定に基づいて、あなたの好みにぴったりの食事をご提案します。後から設定でいつでも変更できます。"
    },
    "healthGoals": {
      "better_sleep": "質の良い睡眠",
      "reduce_stress": "ストレス解消",
      "increase_energy": "活力を高める",
      "weight_management": "体重管理",
      "improve_fitness": "フィットネス向上",
      "better_nutrition": "食生活の改善",
      "mental_wellness": "心の健康",
      "chronic_condition": "持病のケア"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "メンタルヘルス",
        "description": "気分、ストレス、感情の健康を整えます"
      },
      "physical_fitness": {
        "label": "身体のフィットネス",
        "description": "運動、筋力、アクティビティを重視します"
      },
      "nutrition": {
        "label": "栄養バランス",
        "description": "食事の内容や健康的な食習慣を重視します"
      },
      "sleep": {
        "label": "睡眠の質",
        "description": "休息、睡眠パターン、リカバリーを重視します"
      },
      "stress_management": {
        "label": "ストレス管理",
        "description": "リラクゼーションとストレス軽減を重視します"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "西アフリカ",
        "description": "ナイジェリア、ガーナ、セネガル料理など"
      },
      "east_african": {
        "label": "東アフリカ",
        "description": "ケニア、エチオピア、タンザニア料理など"
      },
      "north_african": {
        "label": "北アフリカ",
        "description": "モロッコ、エジプト料理など"
      },
      "southern_african": {
        "label": "南部アフリカ",
        "description": "南アフリカ料理など"
      },
      "caribbean": {
        "label": "カリブ海諸国",
        "description": "ジャマイカ、トリニダード、バルバドス料理など"
      },
      "middle_eastern": {
        "label": "中東",
        "description": "レバノン、パレスチナ、シリア料理など"
      },
      "south_asian": {
        "label": "南アジア",
        "description": "インド、パキスタン、バングラデシュ料理など"
      },
      "east_asian": {
        "label": "東アジア",
        "description": "日本、中国、韓国料理など"
      },
      "southeast_asian": {
        "label": "東南アジア",
        "description": "タイ、ベトナム、インドネシア料理など"
      },
      "western": {
        "label": "欧米",
        "description": "アメリカ、ヨーロッパ料理など"
      },
      "latin_american": {
        "label": "中南米",
        "description": "メキシコ、ブラジル、アルゼンチン料理など"
      },
      "mediterranean": {
        "label": "地中海",
        "description": "ギリシャ、イタリア、スペイン料理など"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "伝統的",
        "description": "主に自分の文化圏の料理"
      },
      "mixed": {
        "label": "ミックス",
        "description": "家庭の味と国際的な料理のバランス"
      },
      "international": {
        "label": "インターナショナル",
        "description": "多様な世界の料理"
      }
    },
    "cuisines": {
      "west_african": "西アフリカ料理",
      "caribbean": "カリブ料理",
      "mediterranean": "地中海料理",
      "asian": "アジア料理",
      "western": "洋食・欧米料理",
      "indian": "インド料理",
      "middle_eastern": "中東料理",
      "general": "すべての料理"
    },
    "dietary": {
      "vegetarian": "ベジタリアン",
      "vegan": "ヴィーガン",
      "pescatarian": "ペスカタリアン",
      "gluten_free": "グルテンフリー",
      "dairy_free": "乳製品フリー",
      "low_carb": "低糖質"
    },
    "allergies": {
      "nuts": "ナッツ類",
      "shellfish": "甲殻類",
      "dairy": "乳製品",
      "eggs": "卵",
      "soy": "大豆",
      "gluten": "グルテン"
    },
    "cuisine_nigerian": "ナイジェリア料理",
    "cuisine_ghanaian": "ガーナ料理",
    "cuisine_senegalese": "セネガル料理",
    "cuisine_kenyan": "ケニア料理",
    "cuisine_ethiopian": "エチオピア料理",
    "cuisine_moroccan": "モロッコ料理",
    "cuisine_south_african": "南アフリカ料理",
    "cuisine_jamaican": "ジャマイカ料理",
    "cuisine_trinidadian": "トリニダード・トバゴ料理",
    "cuisine_lebanese": "レバノン料理",
    "cuisine_turkish": "トルコ料理",
    "cuisine_greek": "ギリシャ料理",
    "cuisine_italian": "イタリア料理",
    "cuisine_french": "フランス料理",
    "cuisine_british": "イギリス料理",
    "cuisine_indian_south": "南インド料理",
    "cuisine_indian_north": "北インド料理",
    "cuisine_pakistani": "パキスタン料理",
    "cuisine_japanese": "日本料理",
    "cuisine_chinese": "中華料理",
    "cuisine_korean": "韓国料理",
    "cuisine_vietnamese": "ベトナム料理",
    "cuisine_thai": "タイ料理",
    "cuisine_filipino": "フィリピン料理",
    "cuisine_american": "アメリカ料理",
    "cuisine_mexican": "メキシコ料理",
    "cuisine_brazilian": "ブラジル料理",
    "cuisine_peruvian": "ペルー料理"
  },
  "dashboard": {
    "welcome": "おかえりなさい",
    "greeting": "こんにちは",
    "goodMorning": "おはようございます",
    "goodAfternoon": "こんにちは",
    "goodEvening": "こんばんは",
    "tagline": "小さな健康への一歩が、大きな変化につながります",
    "microcopy": "あなたの健康への歩みを大切に。",
    "welcomeSubtitleMorning1": "穏やかな一日の始まりですね。",
    "welcomeSubtitleMorning2": "朝のチェックイン、ありがとうございます。",
    "welcomeSubtitleMorning3": "日々の積み重ねを大切に。",
    "welcomeSubtitleAfternoon1": "順調な一日を過ごせますように。",
    "welcomeSubtitleAfternoon2": "HealthLoopへようこそ。",
    "welcomeSubtitleAfternoon3": "一息ついて、自分をいたわりましょう。",
    "welcomeSubtitleEvening1": "一日の疲れを癒しましょう。",
    "welcomeSubtitleEvening2": "穏やかな夜をお過ごしください。",
    "welcomeSubtitleEvening3": "今夜もお疲れ様でした。",
    "title": "予防医学インテリジェンス・プラットフォーム",
    "subtitle": "不調が大きくなる前に、記録、学習、対策を",
    "summary": "ヘルス・インテリジェンス概要",
    "summaryDesc": "予防、学習、参加、ウェルネスのリアルタイム・インサイト",
    "comprehensiveSupport": "予防、教育、エンゲージメント、ウェルネスを通じた総合サポート",
    "todayCheckIn": "今日のチェックイン",
    "quickActions": "クイック操作",
    "healthOverview": "健康の全体像",
    "recentActivity": "最近の活動",
    "viewAll": "すべて表示",
    "preventiveHealth": "予防医学",
    "preventiveHealthDesc": "日々の記録、健康モニタリング、予防アラート",
    "education": "学習",
    "educationDesc": "根拠に基づく知識、健康コラム、専門家の手引き",
    "engagement": "参加",
    "engagementDesc": "コミュニティチャレンジ、習慣管理、相互サポート",
    "wellness": "ウェルネス",
    "wellnessDesc": "スマートな栄養管理、生活バランス、ホリスティックな健康",
    "todaysInsight": "今日のヒント",
    "wellnessScore": "ウェルネススコア",
    "healthStreak": "継続日数",
    "days": "日",
    "logHealth": "健康状態を記録",
    "getEducated": "知識を深める",
    "communityChallenge": "コミュニティへの挑戦",
    "checkWellness": "ウェルネスを確認",
    "verified": "認証済み",
    "joinCommunity": "コミュニティに参加",
    "personalizedPlan": "個人プラン",
    "score": "スコア",
    "checkIns": "チェックイン数",
    "habits": "習慣数",
    "preventive": "予防",
    "healthMetrics": "健康指標",
    "trackMetrics": "指標を記録",
    "startTracking": "記録をはじめる",
    "logMetrics": "数値を入力",
    "dailyInsight": "デイリーインサイト",
    "learnAbout": "今日の予防医学を学ぶ",
    "articlesAvailable": "件の記事があります",
    "browseArticles": "記事一覧を見る",
    "currentStreak": "現在の継続日数",
    "keepGoing": "その調子です！",
    "startStreak": "今日からスタート",
    "checkIn": "チェックイン",
    "nutritionPlan": "栄養計画",
    "mealsPlanned": "予定された食事",
    "viewPlan": "プランを見る",
    "planYourWeek": "一週間の計画を立てる",
    "moodStress": "気分とストレス",
    "howFeeling": "今の気分はどうですか？",
    "logWellness": "ウェルネスを記録",
    "medications": "お薬",
    "noMeds": "登録された薬はありません",
    "addMedications": "お薬を追加する",
    "daysTracked": "記録日数",
    "noHabits": "習慣がまだ登録されていません",
    "startTrackingHabits": "習慣の記録をはじめる",
    "insights": "インサイト",
    "noInsights": "インサイトはまだありません",
    "completeFirstPlan": "最初のプランを完了しましょう",
    "noCheckIns": "チェックイン履歴がありません",
    "startFirstCheckIn": "最初のチェックインをしましょう"
  },
  "support": {
    "title": "サポート",
    "subtitle": "質問への回答、お問い合わせ、問題の報告",
    "backToSettings": "設定に戻る",
    "privacyBanner": "サポートへのリクエストは安全に管理されます。健康情報は機密として扱われます。",
    "section1": "セクション 1",
    "section2": "セクション 2",
    "section3": "セクション 3",
    "section4": "セクション 4",
    "navHelpCenter": "ヘルプセンター",
    "navContact": "サポートに問い合わせ",
    "navHealth": "健康サポートサービス",
    "navTechnical": "技術サポート",
    "helpCenterTitle": "ヘルプセンター",
    "helpCenterSubtitle": "よくある質問から素早く答えを見つけることができます。",
    "contactTitle": "サポートへのお問い合わせ",
    "contactSubtitle": "ご希望の方法でチームにお問い合わせください。",
    "healthServicesTitle": "健康サポートサービス",
    "healthServicesSubtitle": "お薬の管理や専門家との連携が可能です。",
    "technicalTitle": "技術サポート",
    "technicalSubtitle": "不具合や技術的な問題を詳しく報告します。",
    "searchPlaceholder": "よくある質問を検索…",
    "liveChat": "ライブチャット",
    "emailUs": "メールで問い合わせ",
    "callBack": "折り返し電話の予約",
    "sendMessage": "メッセージを送信",
    "medicationTracking": "お薬の管理",
    "specialistAccess": "専門家へのアクセス",
    "videoConsultation": "ビデオ相談",
    "reportBug": "不具合を報告",
    "yourName": "お名前",
    "yourEmail": "メールアドレス",
    "subject": "件名",
    "message": "メッセージ",
    "phone": "電話番号",
    "description": "内容",
    "submit": "送信",
    "successTitle": "メッセージを送信しました",
    "successDescription": "24〜48時間以内に返信いたします。",
    "healthDisclaimer": "緊急を要する場合は、地域の救急サービスに連絡してください。HealthLoopは専門的な医療提供に代わるものではありません。"
  },
  "nutrition": {
    "smartNutrition": "スマート栄養管理",
    "basedOnGoal": "目標に基づく提案:",
    "personalizedData": "最近の健康データに基づきパーソナライズ",
    "evidenceBased": "予防医学プランの一部として、根拠に基づく栄養を提案",
    "todaysMealSuggestions": "今日の提案メニュー",
    "customize": "カスタマイズ",
    "breakfast": "朝食",
    "lunch": "昼食",
    "dinner": "夕食",
    "loadingBreakfast": "朝食を読み込み中...",
    "loadingLunch": "昼食を読み込み中...",
    "loadingDinner": "夕食を読み込み中...",
    "cal": "kcal",
    "protein": "たんぱく質",
    "swapMeal": "メニューを変更",
    "healthyOptionsNearYou": "近くのヘルシーな選択肢",
    "enableLocation": "位置情報を有効にする",
    "view": "見る",
    "discoverOptions": "近くの健康的なレストラン、食料品店、配食ベンダーを探す",
    "cuisinesSelected": "個の料理を選択中",
    "cuisineSelected": "個の料理を選択中",
    "dietaryPrefs": "個の食事設定",
    "dietaryPref": "個の食事設定",
    "customizeMeals": "食事をカスタマイズ",
    "subtitleAdaptive": "文化に合わせ、健康目標に寄り添った個人向け食事プラン",
    "hideFavorites": "お気に入りを隠す",
    "viewFavorites": "お気に入りを見る",
    "customizeMealsLegacy": "文化的な好みや食事制限に合わせて食事をカスタマイズ",
    "viewFullPlan": "プラン全体を見る",
    "exploreRecipes": "レシピを探す"
  },
  "location": {
    "permissionTitle": "近くのヘルシーな選択肢を見つける",
    "permissionDesc": "健康目標に合ったレストラン、商店、配食ベンダーを提案するために使用します。",
    "howToEnable": "有効にする方法:",
    "step1": "ブラウザのアドレスバーにある鍵アイコン 🔒 をクリック",
    "step2": "「位置情報」の権限を探す",
    "step3": "「許可」に変更",
    "step4": "このページを再読み込み",
    "refreshPage": "ページを再読み込み",
    "allowLocation": "位置情報を許可する",
    "notNow": "今はしない",
    "denied": "位置情報へのアクセスが拒否されました。近くの情報を表示するには、権限を有効にする必要があります。",
    "unavailable": "位置情報を取得できません。デバイスの設定を確認してください。",
    "error": "位置情報にアクセスできません。もう一度試すか、ブラウザの設定を確認してください。",
    "unsupported": "お使いのブラウザは位置情報サービスをサポートしていません。最新のChrome、Firefox、Safariなどをお試しください。",
    "accessRequired": "位置情報のアクセスが必要です"
  },
  "womensHealth": {
    "title": "ウィメンズヘルス",
    "description": "生理周期の記録、症状のログ、周期に応じたウェルネスアドバイス",
    "cycleTracking": "周期管理",
    "symptomLogging": "症状の記録",
    "phaseInsights": "フェーズ別インサイト",
    "logPeriod": "生理を記録",
    "logSymptoms": "症状を記録",
    "insights": "インサイト",
    "tips": "健康アドバイス",
    "overview": "概要",
    "history": "履歴",
    "startTracking": "周期の記録をはじめる"
  },
  "profile": {
    "title": "プロフィール",
    "personalInfo": "個人情報",
    "healthProfile": "ヘルスプロフィール",
    "preferences": "設定",
    "language": "言語",
    "selectLanguage": "言語を選択",
    "notifications": "通知",
    "privacy": "プライバシー",
    "security": "セキュリティ",
    "quickAccess": "クイックアクセス",
    "editProfile": "プロフィール編集",
    "viewStats": "統計を見る",
    "backToDashboard": "ホームに戻る",
    "womensHealthTitle": "ウィメンズヘルス",
    "womensHealthDesc": "周期管理、症状記録、アドバイス",
    "healthRemindersTitle": "健康リマインダー",
    "healthRemindersDesc": "通知の設定を管理",
    "manageRemindersDesc": "リマインダー設定と通知の管理",
    "healthPatternAlerts": "健康パターンのアラート",
    "supportHelp": "サポートとヘルプ",
    "supportHelpDesc": "サポート依頼、不具合報告、FAQ",
    "admin": "管理",
    "adminDesc": "利用統計とユーザー行動の分析",
    "giveFeedback": "フィードバックを送る",
    "giveFeedbackDesc": "HealthLoopの感想を共有",
    "reportProblem": "問題を報告",
    "reportProblemDesc": "バグの修正やアプリ改善への協力",
    "manageHealthInfo": "最適なアドバイスのために予防医学情報を管理",
    "basicInformation": "基本情報",
    "fullName": "氏名",
    "email": "メールアドレス",
    "dateOfBirth": "生年月日",
    "gender": "性別",
    "height": "身長 (cm)",
    "weight": "体重 (kg)",
    "medicalConditions": "持病・症状",
    "allergies": "アレルギー",
    "personalHealth": "パーソナルヘルス",
    "addCondition": "持病を追加",
    "addAllergy": "アレルギーを追加",
    "saveChanges": "変更を保存",
    "saving": "保存中...",
    "privacyMessage": "お客様の健康データは守秘義務に基づき厳重に保護されます"
  },
  "settings": {
    "title": "設定",
    "general": "全般",
    "account": "アカウント",
    "appearance": "外観",
    "languageSettings": "言語設定",
    "changeLanguage": "言語を変更",
    "languageNote": "言語を選択すると、すぐにインターフェースに反映されます。アフリカ諸語や新しく追加された言語には「Starter」マークが表示されています。これらは機械翻訳によるもので、現在ネイティブスピーカーによる品質確認を行っております。",
    "languageUpdated": "言語を更新しました",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "機械翻訳によるものです。現在、ネイティブスピーカーによる確認を行っております。",
    "regions": {
      "global": "グローバル",
      "european": "ヨーロッパ言語",
      "middleEastern": "中東言語",
      "asian": "アジア言語",
      "african": "アフリカ言語"
    }
  },
  "search": {
    "triggerLabel": "HealthLoopで検索",
    "triggerHint": "例：「歩数」、「薬局」、「妊娠」",
    "triggerAriaLabel": "全体検索を開く",
    "placeholder": "機能、トラッカー、サポートなどを検索…",
    "inputAriaLabel": "HealthLoopの機能を検索",
    "modalAriaLabel": "HealthLoopを検索",
    "close": "閉じる",
    "clear": "消去",
    "clearAriaLabel": "検索内容を消去",
    "recentSearches": "最近の検索",
    "tryFor": "こちらでお探しですか？",
    "findFeatures": "お探しの機能がすぐに見つかります。",
    "searchAcross": "検索対象：",
    "and": "、",
    "sections": {
      "home": "ホーム",
      "nutrition": "栄養",
      "family": "ファミリー",
      "services": "サービス",
      "support": "サポート",
      "profile": "プロフィール",
      "and": "および"
    },
    "noMatchesFor": "「{{query}}」に一致する結果はありませんでした",
    "trySimpler": "「歩数」、「栄養」、「専門医」など、よりシンプルな言葉でお試しください。",
    "comingSoonBadge": "近日公開",
    "escToClose": "で閉じる",
    "resultSingular": "検索結果：{{count}}件",
    "resultPlural": "検索結果：{{count}}件",
    "searchAcrossApp": "アプリ全体から検索"
  },
  "familyMember": {
    "confirmRemove": "{{name}}さんを家族の健康管理から削除しますか？",
    "removed": "{{name}}さんを家族から削除しました",
    "removeFailed": "メンバーの削除に失敗しました",
    "viewDetails": "詳細を表示",
    "edit": "編集",
    "remove": "削除",
    "yearsSuffix": "歳",
    "healthGoalsLabel": "健康目標：",
    "moreSuffix": "件以上",
    "activeInsights": "現在のアドバイス",
    "viewAllInsights": "{{count}}件のアドバイスをすべて見る →",
    "viewFullProfile": "健康プロファイルをすべて見る",
    "lifeStage": {
      "infant": "乳幼児 (0-2歳)",
      "toddler": "幼児 (2-5歳)",
      "child": "子供 (6-12歳)",
      "adolescent": "ティーン (13-17歳)",
      "adult": "成人 (18-59歳)",
      "senior": "シニア (60歳以上)",
      "unknown": "不明"
    }
  },
  "profileDeep": {
    "backToDashboard": "ダッシュボードに戻る",
    "profileCompletion": "プロフィールの完成度",
    "healthSummary": "ウェルネスの概要",
    "sectionA": "セクション A",
    "sectionB": "セクション B",
    "sectionC": "セクション C",
    "sectionD": "セクション D",
    "personalDetails": "基本情報",
    "healthInformation": "健康状態の情報",
    "accountSettings": "アカウント設定",
    "fullName": "氏名",
    "email": "メールアドレス",
    "dob": "生年月日",
    "gender": "性別",
    "genderPlaceholder": "例：女性、男性、ノンバイナリー",
    "height": "身長 (cm)",
    "heightPlaceholder": "例：170",
    "weight": "体重 (kg)",
    "weightPlaceholder": "例：70",
    "allergies": "アレルギー",
    "allergiesPlaceholder": "例：ピーナッツ",
    "medicalConditions": "持病・既往症",
    "conditionsPlaceholder": "例：高血圧",
    "medications": "服用中の薬",
    "medicationsPlaceholder": "例：リシノプリル 10mg、毎日",
    "emergencyContact": "緊急連絡先",
    "emergencyOptional": "（任意）",
    "emergencyPlaceholder": "例：母 090-0000-0000",
    "emergencyNote": "あなたが同意した場合にのみ、専門家との共有用サマリーに含まれます。",
    "saveChanges": "変更を保存",
    "saving": "保存中…",
    "editProfile": "プロフィールを編集",
    "cancelEditing": "編集をキャンセル",
    "healthScore": "ヘルススコア",
    "streak": "継続日数",
    "streakDays": "{{n}} 日",
    "memberSince": "登録日",
    "remindersActive": "リマインダー設定中",
    "conditionsTracked": "追跡中の項目",
    "nextAgenda": "次に行うこと",
    "notificationsReminders": "通知とリマインダー",
    "notificationsRemindersDesc": "通知の時間や方法を管理します",
    "emailNudges": "メールでの通知",
    "emailNudgesDesc": "穏やかなリマインダーと週間のまとめをお届けします",
    "on": "オン",
    "paused": "一時停止中",
    "privacySecurity": "プライバシーとセキュリティ",
    "privacySecurityDesc": "パスワードを更新してアカウントを安全に保ちます",
    "preferencesTitle": "設定",
    "preferencesDesc": "言語、地域、パーソナライズ設定",
    "supportHelp": "サポートとヘルプ",
    "supportHelpDesc": "よくある質問やお問い合わせ",
    "giveFeedback": "フィードバックを送る",
    "giveFeedbackDesc": "改善点をお聞かせください",
    "reportProblem": "問題を報告する",
    "reportProblemDesc": "不具合を見つけた場合はこちらから",
    "adminInsights": "管理者用インサイト",
    "adminInsightsDesc": "利用状況の分析",
    "adminBadge": "管理者",
    "shareWithClinician": "専門家と共有する",
    "shareWithClinicianDesc": "閲覧専用のサマリー ・ 自動的に期限切れ ・ いつでも停止可能",
    "share": "共有する",
    "profileMayBeOutOfDate": "プロフィール情報が古い可能性があります",
    "profileMayBeOutOfDateDesc": "より正確な分析のためにデータを最新に保ちましょう。体重や服薬状況などの小さな変化が、あなたにぴったりのアドバイスにつながります。",
    "updateNow": "今すぐ更新",
    "profileUpdateError": "設定を更新できませんでした。もう一度お試しください。",
    "healthLoopUser": "HealthLoop ユーザー",
    "updatedLabel": "更新済み",
    "noEntries": "まだ入力がありません",
    "completionComplete": "プロフィールが完成しました。あなたに最適なガイダンスをお届けします。 💚",
    "completionAlmostThere": "あと少しです。残りの項目を入力すると、より深い分析が可能になります。",
    "completionInProgress": "プロフィールを完成させて、より良いウェルネス・インサイトを確認しましょう。",
    "justNow": "たった今",
    "minAgo": "{{n}} 分前",
    "minsAgo": "{{n}} 分前",
    "hourAgo": "{{n}} 時間前",
    "hoursAgo": "{{n}} 時間前",
    "dayAgo": "{{n}} 日前",
    "daysAgo": "{{n}} 日前",
    "checkinDueToday": "本日のチェックイン期限",
    "checkinDueTonight": "今夜のチェックイン期限"
  },
  "supportDeep": {
    "backToSettings": "設定に戻る",
    "quickNavAria": "サポートセクション",
    "searchPlaceholder": "ヘルプを検索…",
    "searchAria": "よくある質問を検索",
    "resultsCount": "件の検索結果：{{n}}",
    "resultsCountPlural": "件の検索結果：{{n}}",
    "questionsCount": "件の質問：{{n}}",
    "liveChatTitle": "ライブチャット",
    "liveChatDesc": "リアルタイムでお答えします ・ 月〜金 9:00〜18:00",
    "startChat": "チャットを開始",
    "liveChatSoonToast": "ライブチャットは近日公開予定です。それまではメールでお問い合わせください。",
    "emailUsTitle": "メールでのお問い合わせ",
    "emailUsDesc": "24〜48時間以内に返信いたします",
    "copy": "コピー",
    "emailCopied": "メールアドレスをクリップボードにコピーしました",
    "contactFormTitle": "お問い合わせフォーム",
    "contactFormDesc": "メッセージをお送りください。メールで返信いたします。",
    "yourNameLabel": "お名前 *",
    "namePlaceholder": "山田 花子",
    "yourEmailLabel": "メールアドレス *",
    "emailPlaceholder": "hanako@example.com",
    "subjectOptional": "件名（任意）",
    "subjectPlaceholder": "どのようなご用件でしょうか？",
    "messageLabel": "メッセージ内容 *",
    "messagePlaceholder": "ご不明な点などを詳しくお聞かせください。",
    "sending": "送信中…",
    "sendMessage": "メッセージを送信",
    "messageSent": "メッセージを送信しました",
    "messageSentDesc": "24〜48時間以内に返信いたします。",
    "callbackTitle": "電話による折り返しを依頼",
    "callbackDesc": "ご希望の時間帯にお電話いたします。",
    "phoneLabel": "電話番号 *",
    "phonePlaceholder": "090-0000-0000",
    "preferredTimeLabel": "希望の時間帯（任意）",
    "preferredTimePlaceholder": "例：明日の午後",
    "reasonLabel": "理由（任意）",
    "reasonPlaceholder": "どのような内容についてお話しされますか？",
    "submitting": "送信中…",
    "requestCallback": "折り返しを依頼する",
    "callbackRequested": "折り返しを承りました",
    "callbackRequestedDesc": "24時間以内にご連絡いたします。",
    "medicationSupport": "お薬サポート",
    "medicationSupportDesc": "処方箋の追跡や補充のリマインダー",
    "goToMedications": "お薬の管理へ →",
    "specialistConsultation": "専門家への相談",
    "specialistConsultationDesc": "パーソナライズされたウェルネス指導のために専門家とつながります。",
    "connectExpert": "専門家に相談する →",
    "videoConsult": "ビデオ相談",
    "videoConsultDesc": "専門家との対面ビデオセッションを予約します。",
    "bookConsultation": "相談を予約する →",
    "premium": "プレミアム",
    "healthDisclaimer": "HealthLoopは日々のウェルネスをサポートするものであり、緊急の医療行為に代わるものではありません。緊急を要する場合は、直ちに救急サービスをご利用ください。",
    "categoryLabel": "カテゴリー",
    "catBug": "バグ・不具合",
    "catPerformance": "動作が遅い",
    "catFeature": "機能が動作しない",
    "catUi": "表示の問題",
    "catOther": "その他",
    "issueTitle": "問題の件名 *",
    "issueTitlePlaceholder": "簡潔な要約",
    "detailedDescription": "詳細な説明 *",
    "detailedDescriptionPlaceholder": "何が起きましたか？どのような操作をしている時に発生しましたか？再現手順をいただけると助かります。",
    "autoAttachNote": "デバイス、ブラウザ、表示サイズの情報は自動的に添付されます。",
    "submitReport": "レポートを送信",
    "reportSubmitted": "レポートを送信しました",
    "reportSubmittedDesc": "担当チームが確認いたします。",
    "fillAllFields": "必須項目をすべて入力してください",
    "problemReportSubmittedToast": "問題を報告しました。調査の上、追ってご連絡いたします。",
    "messageSentToast": "メッセージを送信しました。24〜48時間以内に返信いたします。",
    "callRequestedToast": "電話の依頼を承りました。24時間以内にご連絡いたします。",
    "submitFailGeneric": "送信に失敗しました。もう一度試すか、{{email}} までメールでお送りください。",
    "submitFailContact": "送信できませんでした。{{email}} まで直接メールをお送りください。",
    "comingSoon": "近日公開",
    "specialistRoadmapTitle": "専門家への相談",
    "specialistRoadmapSubtitle": "専門家によるサポートを準備中です。必要な時にすぐ相談できるようになります。",
    "talkToSpecialistTitle": "専門家とチャット",
    "talkToSpecialistDesc": "日常の健康に関する疑問を、資格を持つ専門家とリアルタイムでチャットできます。",
    "bookSpecialistTitle": "専門家を予約",
    "bookSpecialistDesc": "あなたの目標に合わせた専門家との1対1のセッションを予約できます。",
    "liveHealthGuidanceTitle": "ライブ・ウェルネス・ガイダンス",
    "liveHealthGuidanceDesc": "気になる症状や検査結果などについて、ビデオ通話でアドバイスを受けられます。",
    "mentalWellnessTitle": "メンタル・ウェルネス・サポート",
    "mentalWellnessDesc": "心が疲れた時、専門家による機密性の高いサポートを受けられます。",
    "wellnessNavigationTitle": "ウェルネス・ナビゲーション",
    "wellnessNavigationDesc": "次にどのような行動をとるべきか、ガイド付きでご案内します。",
    "pharmacyRoadmapTitle": "お薬と調剤サポート",
    "pharmacyRoadmapSubtitle": "お薬に関する相談も「サポートとヘルプ」から簡単に行えるようになります。",
    "medicationGuidanceTitle": "お薬ガイド",
    "medicationGuidanceDesc": "服用量、タイミング、飲み合わせなどについて分かりやすく解説します。",
    "findNearbyPharmacyTitle": "近くの薬局を探す",
    "findNearbyPharmacyDesc": "お薬が必要な際、お近くの信頼できる薬局を素早く見つけられます。",
    "refillReminderTitle": "お薬の補充リマインダー",
    "refillReminderDesc": "大切なお薬を切らさないよう、穏やかな通知でお知らせします。",
    "otcWellnessTitle": "市販薬のアドバイス",
    "otcWellnessDesc": "根拠に基づいた安全な市販薬の選び方をガイドします。"
  },
  "careServices": {
    "pageTitle": "ケアサービス",
    "pageSubtitle": "日々の健康を支える、専門家によるウェルネスサポート。",
    "specialistCareTitle": "専門家によるケア",
    "specialistCareSubtitle": "必要な時に、専門家への相談や予約が可能です。",
    "medicationPharmacyTitle": "お薬と調剤",
    "medicationPharmacySubtitle": "お薬に関する分かりやすいガイドと薬局のサポート。",
    "wellnessSupportTitle": "ウェルネス・サポート",
    "wellnessSupportSubtitle": "メンタルケアや市販薬の選び方、次のステップへの指針。",
    "futureWellnessTitle": "今後のウェルネス機能",
    "futureWellnessSubtitle": "HealthLoopが予定している予防ウェルネスのロードマップです。",
    "futureFeatureBadge": "今後追加予定の機能",
    "futurePersonalizedMealsTitle": "パーソナライズ献立プラン",
    "futurePersonalizedMealsDesc": "目標、アレルギー、食文化に合わせたウェルネス献立。",
    "futureHealthyDeliveryTitle": "ヘルシー食のデリバリー",
    "futureHealthyDeliveryDesc": "健康に配慮した提携店からのデリバリーサービス。",
    "futureFarmFreshTitle": "産地直送のウェルネス食材",
    "futureFarmFreshDesc": "地域の農家や季節の新鮮食材パートナーとの直接連携。",
    "futureFoodPartnershipsTitle": "ウェルネスフード提携",
    "futureFoodPartnershipsDesc": "厳選された飲食店や食料品店、ウェルネスブランドとの連携。",
    "futureNutritionCoachingTitle": "栄養コーチング",
    "futureNutritionCoachingDesc": "資格を持つ栄養コーチによる1対1の指導。",
    "futureFamilyWellnessTitle": "家族のウェルネスプラン",
    "futureFamilyWellnessDesc": "家族全員の健康維持をサポートする共有プラン。",
    "futureWellnessPlusTitle": "Wellness+ メンバーシップ",
    "futureWellnessPlusDesc": "より詳細な分析や優先サポートが受けられるプレミアムプラン。",
    "futurePharmacyPartnersTitle": "薬局パートナーシップ",
    "futurePharmacyPartnersDesc": "お薬の相談や補充ができる信頼できる薬局との連携。",
    "futureAdvancedSpecialistTitle": "高度な専門ケア",
    "futureAdvancedSpecialistDesc": "専門医へのスムーズなアクセスやセカンドオピニオンのサポート。",
    "futureWellnessMarketplaceTitle": "ウェルネス・マーケットプレイス",
    "futureWellnessMarketplaceDesc": "厳選されたウェルネス製品やサービスを取り扱うショップ。",
    "futureVendorCollabTitle": "パートナー連携システム",
    "futureVendorCollabDesc": "健康食品やウェルネスパートナー向けの品質管理システム。"
  },
  "dashboardDeep": {
    "healthProfile": "ヘルスプロフィール",
    "notifications": "通知",
    "familyAccounts": "家族アカウント",
    "settings": "設定",
    "logout": "ログアウト",
    "allCaughtUp": "すべて確認済みです",
    "weekInReview": "今週の振り返り",
    "dismissNotification": "通知を閉じる",
    "dismissWeeklyDigest": "今週のまとめを閉じる",
    "notificationsAria": "通知",
    "profileMenuAria": "プロフィールメニューを開く",
    "loadingWellness": "ウェルネスサマリーを読み込み中",
    "nextTip": "次のヒント",
    "todayAtGlance": "今日の概況",
    "healthScoreLabel": "ヘルススコア",
    "currentStreakLabel": "現在の継続日数",
    "todaysProgress": "今日の進捗",
    "insightForYou": "あなたへのインサイト",
    "checkMyHealthRisk": "リスクチェックを行う",
    "quickAccess": "クイックアクセス",
    "exploreCareServicesTitle": "ケアサービスを見る",
    "exploreCareServicesSubtitle": "専門家ケア、お薬、ウェルネスをひとつの場所で。",
    "familyCare": "家族のケア",
    "healthLibrary": "ウェルネス・ライブラリ",
    "myHealthData": "マイデータ",
    "askQuestion": "質問する",
    "dashLoadError": "ダッシュボードを読み込めませんでした。もう一度お試しください。",
    "taskUpdateError": "タスクを更新できませんでした。もう一度お試しください。",
    "perfectDay": "素晴らしい一日です！🎉 継続日数が伸びました。",
    "letsStart": "はじめましょう",
    "yourNextStepToday": "今日、次に行うこと",
    "completeDailyCheck": "今日の健康チェックを完了しましょう",
    "startDailyCheck": "健康チェックを開始",
    "viewAll": "すべて見る",
    "graceProtected": "猶予期間中です",
    "todaysHealthRecommendations": "今日の健康アドバイス",
    "updateViaCheck": "チェックインで更新",
    "healthInsight": "健康インサイト",
    "riskCheckSubtext": "数秒でパーソナライズされたインサイトを表示",
    "foodDiet": "食事と栄養",
    "healthScoreNew": "ヘルススコア ・ 新規",
    "letsBuildScore": "一緒にヘルススコアを積み上げましょう",
    "oneHealthyHabitAtATime": "一歩ずつ、健康な習慣を。",
    "nextCheck": "次のチェック：",
    "todayAt8pm": "本日 午後 8:00",
    "wellnessTipForYou": "今日のウェルネス・ヒント ・ あなたへ",
    "wellnessTipForFactor": "今日のウェルネス・ヒント ・ {{factor}}について",
    "logged": "記録済み",
    "gotIt": "了解です 👍",
    "gladToSeeYou": "今日もご利用ありがとうございます 💚",
    "takesLessThan60Sec": "完了まで60秒以内です",
    "scoreReadyWhenYou": "いつでも開始できます",
    "scoreCompleteFirstCheck": "最初のウェルネスチェックを完了して、インサイトを確認しましょう。",
    "scoreExcellent": "非常に良い",
    "scoreSupportExcellent": "素晴らしい状態です。この調子で続けましょう。",
    "scoreGood": "良い",
    "scoreSupportGood": "順調です。健康的な習慣を維持しましょう。",
    "scoreModerate": "普通",
    "scoreSupportModerate": "まずまずの状態ですが、いくつか注意が必要な項目があります。",
    "scoreNeedsAttention": "注意が必要",
    "scoreSupportNeedsAttention": "今日は少し注意が必要です。小さな変化から改善していきましょう。"
  },
  "emailVerify": {
    "bannerWithEmail": "アカウントの安全を保ち、日々の通知をお届けするために、メールアドレス ({{email}}) を認証してください。",
    "bannerNoEmail": "アカウントの安全を保ち、日々の通知をお届けするために、メールアドレスを認証してください。",
    "sending": "送信中…",
    "resend": "メールを再送する",
    "sentToast": "認証メールを送信しました。受信トレイを確認してください。",
    "sendFailToast": "認証メールを送信できませんでした。後ほどもう一度お試しください。"
  },
  "forgotPassword": {
    "title": "パスワードをお忘れですか？",
    "subtitle": "ご心配なく！メールアドレスを入力いただければ、再設定の方法をお送りします。",
    "emailLabel": "メールアドレス",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "再設定用リンクを送信",
    "sending": "送信中…",
    "backToLogin": "ログインに戻る",
    "resendLink": "メールを再送する",
    "successTitle": "メールを確認してください",
    "successBody": "{{email}} のアカウントが存在する場合、パスワード再設定用のリンクをお送りしました。",
    "linkExpires": "リンクの有効期限は30分です。",
    "successToast": "再設定手順をメールでお送りしました",
    "errEmptyEmail": "メールアドレスを入力してください",
    "errInvalidEmail": "有効なメールアドレスを入力してください",
    "errNetwork": "サーバーに接続できません。通信状況を確認してもう一度お試しください。",
    "errGeneric": "再設定メールを送信できませんでした。もう一度試すかサポートにお問い合わせください。"
  },
  "resetPassword": {
    "title": "新しいパスワードの設定",
    "subtitle": "強力なパスワードを作成してください",
    "newPasswordLabel": "新しいパスワード",
    "newPasswordPlaceholder": "新しいパスワードを入力",
    "confirmPasswordLabel": "パスワードの確認",
    "confirmPasswordPlaceholder": "新しいパスワードを再入力",
    "requirementsHint": "大文字、小文字、数字を含む8文字以上で設定してください",
    "resetPassword": "パスワードをリセット",
    "resetting": "リセット中…",
    "successTitle": "パスワードをリセットしました！",
    "successBody": "新しいパスワードでログインできるようになりました。",
    "successToast": "パスワードを正常にリセットしました",
    "goToLogin": "ログインへ",
    "invalidLinkTitle": "無効なリンク",
    "invalidLinkBody": "このパスワード再設定リンクは無効か、有効期限が切れています。",
    "requestNewLink": "新しいリンクをリクエスト",
    "showPassword": "パスワードを表示",
    "hidePassword": "パスワードを非表示",
    "errInvalidLink": "無効なリセットリンクです",
    "errMismatch": "パスワードが一致しません",
    "errTooShort": "パスワードは8文字以上で入力してください",
    "errExpiredToken": "このリンクは期限切れか無効です。新しくリクエストしてください。",
    "errNetwork": "サーバーに接続できません。通信状況を確認してもう一度お試しください。",
    "errGeneric": "パスワードのリセットに失敗しました。もう一度お試しください。"
  },
  "tips": {
    "water1": "起床後30分以内に水を飲むと、水分補給とエネルギーアップにつながります。",
    "water2": "毎食前にコップ1杯の水を飲む習慣は、喉の渇きを未然に防ぐ穏やかな方法です。",
    "water3": "レモンやミントの葉を少し加えるだけで、水分補給がより楽しくなります。",
    "meals1": "1日1品、野菜の摂取を増やすことは、腸内環境や健康の維持に役立ちます。",
    "meals2": "朝食にひと掴みのナッツや種子類を加えると、午前中の活力を安定させてくれます。",
    "meals3": "果汁よりも果物そのものを。食物繊維が含まれるため、糖の吸収が穏やかになります。",
    "steps1": "食後の10分間の散歩は、体が穏やかにエネルギーを処理するのを助けます。",
    "steps2": "朝の5分間のストレッチは、緊張をほぐし、一日を穏やかな気持ちで始めるのに役立ちます。",
    "steps3": "1日1回でも階段を使うことで、数週間かけて自然に体力が養われます。",
    "sleep1": "寝る1時間前から照明を落とすと、体が休息モードに入り、深い眠りにつきやすくなります。",
    "sleep2": "週末も含めて決まった時間に起きることは、安定した睡眠リズムの鍵となります。",
    "sleep3": "朝に10分間日光を浴びることで、自然に睡眠リズムが整います。",
    "general1": "2分間のゆっくりとした呼吸は、ストレスを和らげ、集中力を整えてくれます。",
    "general2": "今日、感謝できることを一つ探してみましょう。心の小さなポジティブが大きな変化を生みます。",
    "general3": "今日ここを開いたことが素晴らしい一歩です。その継続が他の習慣をより簡単にしていきます。"
  },
  "factors": {
    "hydration": "水分補給",
    "nutrition": "栄養",
    "movement": "運動",
    "sleep": "睡眠"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "食事の選択肢の読み込みに失敗しました",
    "prefsSaved": "食事の好みを保存しました！メニューを更新しています...",
    "prefsSaveFail": "好みの保存に失敗しました",
    "newOptionsFail": "新しい選択肢の読み込みに失敗しました",
    "invalidZip": "有効な5桁の郵便番号を入力してください",
    "noVendorsArea": "このエリアではまだ提供業者がありません。順次拡大中です！",
    "vendorsFetchFail": "提供業者の取得に失敗しました",
    "selectVendorFirst": "先に配送業者を選択してください",
    "removedFromCart": "カートから削除しました",
    "orderPlaced": "注文が完了しました！ 🎉",
    "enterZipFirst": "先に配送セクションで郵便番号を入力してください",
    "mealNotAvailable": "このメニューはお住まいの地域ではまだ配送に対応していません",
    "mealUnavailable": "このメニューは現在、近隣の提供業者で取り扱いがありません",
    "vendorOptionsFail": "提供業者の選択肢の読み込みに失敗しました",
    "favoriteSaveFail": "お気に入りの保存に失敗しました",
    "removedFromFavorites": "お気に入りから削除しました",
    "favoriteRemoveFail": "お気に入りの削除に失敗しました",
    "cartEmpty": "カートは空です",
    "noMealOptions": "利用可能なメニューがありません",
    "loadingOptions": "メニューを読み込んでいます...",
    "selectPreferences": "食事の好みを選択する",
    "mealBuilder": "ミールビルダー",
    "myFavorites": "お気に入り",
    "myFavoriteMeals": "お気に入りのメニュー",
    "noFavoritesYet": "お気に入りのメニューはまだありません",
    "price": "価格",
    "delivery": "配送",
    "deliveryFee": "配送料",
    "distance": "距離",
    "subtotal": "小計",
    "total": "合計",
    "orderNumber": "注文番号",
    "vendor": "提供業者",
    "totalAmount": "合計金額",
    "estimatedDelivery": "お届け予定",
    "whyThisMeal": "おすすめの理由",
    "selectThisMeal": "このメニューを選ぶ",
    "swapMeal": "メニューを変更する",
    "orderThisMeal": "このメニューを注文する",
    "notAvailableNearYou": "周辺で利用不可",
    "tryAdjustingPrefs": "食事の好みを調整して、おすすめの提案を表示してみてください",
    "myMealPlanSummary": "食事プランの概要",
    "saveCompletePlan": "プラン全体を保存",
    "yourFoodPreferences": "あなたの食事の好み",
    "editPreferences": "好みを編集する",
    "healthyMealDelivery": "ヘルシーメニューの配送",
    "enableDelivery": "配送を有効にする",
    "enterZipCode": "郵便番号を入力して利用可能なメニューを確認",
    "enterPostcode": "郵便番号を入力してください",
    "postcodePlaceholder": "例：100-0001",
    "postcodePartialHint": "より正確な検索結果を表示するために、正しい郵便番号を入力してください。",
    "noLocalPartnersFallback": "近隣の提携先が見つかりませんでした。代わりに地域に合った食材の提案を表示しています。",
    "noLivePartnersFallback": "お住まいの地域では、HealthLoopの提携業者はまだ活動していません。",
    "culturalNutritionTitle": "地域のヘルシー食材",
    "culturalNutritionSubtitle": "地域や文化に合わせた、パーソナライズされた健康的なライフスタイルのための案内です。",
    "viewIngredientGuidance": "ガイダンスを見る",
    "popularWellnessTitle": "周辺で人気のウェルネス食材",
    "popularWellnessIntro": "お住まいの地域で一般的に親しまれている、健康的で文化に根ざした食材を紹介します。",
    "subsectionPopularFoodsTitle": "毎日のウェルネス食材",
    "subsectionCulturalIngredientsTitle": "おすすめの文化的食材",
    "subsectionHealthySwapsTitle": "ヘルシーな置き換えアイデア",
    "subsectionLocalEnvironmentTitle": "地域のウェルネス環境",
    "subsectionLocalEnvironmentIntro": "お住まいの地域でヘルシーな選択肢が見つかる場所を紹介します。",
    "findLocalTitle": "地域のヘルシーな選択肢",
    "findLocalSubtitle": "近くのヘルシーな店舗やショップ、文化に根ざした食材を見つけましょう。",
    "findOptions": "選択肢を探す",
    "searching": "検索中...",
    "nearbyVendorsFound": "{{count}}件の周辺のヘルシーな選択肢が見つかりました",
    "orderHintEnabled": "メニューカードの「このメニューを注文する」をタップすると、価格を確認できます。",
    "orderHintDisabled": "上記の「配送を有効にする」をオンにすると、メニューカードから直接注文できます。",
    "localIngredientTitle": "地域の食材情報",
    "localIngredientIntro": "文化的に親しみのある定番食材と、その入手場所について案内します。",
    "lookFor": "注目のポイント",
    "noVendorsFallback": "認定配送業者はまだありませんが、上記の食材案内は地元のスーパーや直売所での買い物に役立ちます。",
    "showingMealsFrom": "表示中のメニュー提供元：",
    "sectionSnapshot": "今日の栄養スナップショット",
    "sectionSnapshotSubtitle": "水分補給、カロリー、食事のバランスを素早くチェックしましょう。",
    "snapshotHydration": "水分補給",
    "snapshotHydrationHint": "今日はコップ6〜8杯を目指しましょう。",
    "snapshotCalories": "カロリー",
    "snapshotCaloriesHint": "記録機能は近日公開予定です。",
    "snapshotBalance": "食事バランス",
    "mealsLogged": "食事が選択されました",
    "snapshotTip": "ウェルネス・チップス",
    "snapshotTipHint": "次の食事に野菜をもう一品追加してみましょう。",
    "sectionRecommendations": "スマート・レコメンド",
    "sectionRecommendationsSubtitle": "地域に合わせた食材案内とヘルシーな置き換え案です。",
    "sectionGoals": "栄養目標",
    "sectionGoalsSubtitle": "あなたにとって大切な指標を記録しましょう。",
    "goalWeight": "適正体重の維持",
    "goalWeightDesc": "無理のない体重管理に適したメニューです。",
    "goalEnergy": "エネルギーの維持",
    "goalEnergyDesc": "一日中元気に過ごすための持続的な燃料となります。",
    "goalImmunity": "免疫力の維持",
    "goalImmunityDesc": "健康を保つための、抗酸化成分が豊富な選択肢です。",
    "goalFamily": "家族の栄養",
    "goalFamilyDesc": "お子様や妊産婦の方に適した選択肢も含まれています。",
    "sectionGuidance": "食事ガイダンス",
    "sectionGuidanceSubtitle": "自由に選べる朝食、昼食、夕食、間食のアイデアです。",
    "futureNutritionTitle": "今後の栄養サポート",
    "futureNutritionBody": "パーソナライズされた栄養アドバイスや提携パートナー、家族向けサポートを今後のアップデートでHealthLoopに追加予定です。",
    "comingSoon": "近日公開",
    "coverageLocalStores": "地域のヘルシーショップ",
    "coverageLocalFarms": "地域の農園",
    "coverageCertifiedVendors": "認定ベンダー",
    "coverageFreshProduce": "新鮮な農産物",
    "medWellnessFutureTitle": "お薬とウェルネスのサポート",
    "medWellnessFutureDesc": "栄養プランと共にお薬に配慮した案内を行います（「サポート＆ヘルプ」内に追加予定）。",
    "pharmacyAssistFutureTitle": "薬局アシスタンス",
    "pharmacyAssistFutureDesc": "食事管理と合わせて、近くの薬局検索や受け取りのリマインダーを提供予定です。",
    "savePreferences": "好みを保存する",
    "quickAccessSavedMeals": "保存したメニューへのクイックアクセス",
    "saveMealsFromBuilder": "ミールビルダーからメニューを保存できます",
    "chooseVendor": "注文する提供業者を選択してください",
    "yourCart": "カート",
    "addMealsToStart": "以下の選択肢からメニューを追加してください",
    "orderPlacedDesc": "ヘルシーメニューの注文が完了しました",
    "continueShopping": "買い物を続ける",
    "trackOrder": "注文状況を確認する",
    "healthyStoresTitle": "お近くのヘルシーショップ ＆ ウェルネスマーケット",
    "healthyStoresIntro": "お住まいの地域で探せる、多様な文化に対応した店舗タイプの例です（デリバリーではなく、お買い物の参考にしてください）。",
    "healthyStoresGuidanceTitle": "ヘルシーなお買い物ガイド",
    "healthyStoresDisclaimer": "HealthLoopは一般的なウェルネス維持やヘルシーなお買い物のヒントを提供しており、医学的診断や食事療法の助言を行うものではありません。",
    "healthyStores": {
      "organic": {
        "type": "オーガニック食品店",
        "description": "新鮮で農薬不使用の農産物や、加工を最小限に抑えた保存食を取り扱っています。",
        "tags": [
          "ホールフード",
          "新鮮な農産物"
        ]
      },
      "farmers": {
        "type": "ファーマーズマーケット（直売所）",
        "description": "地元で育った旬の果物、野菜、伝統的な農産物を生産者から直接購入できます。",
        "tags": [
          "地産地消",
          "旬の食材"
        ]
      },
      "african": {
        "type": "アフリカ食材店",
        "description": "ヤム芋、プランテン、葉物野菜、パームナッツなど、西・東アフリカの主食を取り扱っています。",
        "tags": [
          "文化的食材",
          "新鮮な農産物"
        ]
      },
      "caribbean": {
        "type": "カリブ自然食品店",
        "description": "カラルー、キャッサバ、スコッチボネット、アッキー、パンの実など、島の主食を取り扱っています。",
        "tags": [
          "文化的食材",
          "ホールフード"
        ]
      },
      "asian": {
        "type": "アジア野菜スーパー",
        "description": "チンゲン菜、大根、蓮根、豆腐、新鮮なハーブなど、アジア全域の主食を取り扱っています。",
        "tags": [
          "文化的食材",
          "新鮮な農産物"
        ]
      },
      "halal": {
        "type": "ハラール・ヘルシーマーケット",
        "description": "ハラール認証を受けた脂身の少ないタンパク質、新鮮な農産物、伝統的なスパイスを取り扱っています。",
        "tags": [
          "ハラール",
          "文化的食材"
        ]
      },
      "mediterranean": {
        "type": "地中海ホールフードマーケット",
        "description": "オリーブオイル、豆類、新鮮なハーブ、全粒穀物など、地中海料理の主食を取り扱っています。",
        "tags": [
          "文化的食材",
          "ホールフード"
        ]
      },
      "wellness": {
        "type": "ウェルネス志向の食料品店",
        "description": "厳選されたホールフード、植物性食品、添加物の少ない保存食などを取り扱っています。",
        "tags": [
          "ホールフード",
          "植物性食品"
        ]
      }
    },
    "healthyShoppingTips": [
      "まずは売り場の外周から回りましょう。新鮮な野菜や果物、良質なタンパク質などは外側に配置されることが多いです。",
      "高度に加工された食品よりも、自然に近い単一原材料の食品を選びましょう。",
      "地元の旬の食材を選びましょう。新鮮で手頃な価格なだけでなく、栄養価も高い傾向にあります。",
      "産地や栽培方法を店員さんに尋ねてみましょう。喜んで教えてくれるはずです。"
    ]
  },
  "messages": {
    "success": "成功しました！",
    "error": "エラー",
    "saved": "正常に保存されました",
    "updated": "正常に更新されました",
    "deleted": "正常に削除されました",
    "confirmDelete": "本当に削除してもよろしいですか？",
    "networkError": "ネットワークエラーが発生しました。もう一度お試しください。",
    "somethingWrong": "問題が発生しました",
    "failedToLoad": "ダッシュボードの読み込みに失敗しました",
    "offlineMode": "オフラインモード - 一部のデータを表示しています",
    "locationDenied": "位置情報へのアクセスが拒否されました。ブラウザの設定を確認してください。",
    "locationUnavailable": "位置情報が取得できません",
    "locationTimeout": "位置情報の要求がタイムアウトしました。もう一度お試しください。",
    "locationError": "位置情報にアクセスできません",
    "locationGranted": "アクセスが許可されました！周辺の選択肢を表示します",
    "locationNotSupported": "お使いのブラウザは位置情報サービスをサポートしていません",
    "requestingLocation": "位置情報のアクセスを要求中..."
  },
  "trust": {
    "medicalDisclaimer": "免責事項",
    "privacySecure": "データは安全に保護されています",
    "dataEncrypted": "すべてのデータは暗号化され、機密が保持されます",
    "notMedicalAdvice": "医学的なアドバイスではありません",
    "consultProvider": "必ずかかりつけの医師にご相談ください",
    "evidenceBased": "エビデンスに基づいたガイダンス",
    "generalEducation": "一般的な健康教育",
    "preventiveGuidance": "予防のためのガイダンス",
    "lifestyleSupport": "意識向上とライフスタイル支援のために",
    "lastUpdated": "最終更新日",
    "expertReviewed": "専門家による確認済み",
    "aiGenerated": "AIによるインサイト",
    "disclaimerShort": "HealthLoopは健康教育を提供するものであり、専門的な医学的アドバイスに代わるものではありません。",
    "disclaimerFull": "HealthLoopは、予防的なウェルネスと早期の意識向上をサポートします。健康教育、習慣トラッキング、ウェルネスの洞察を提供しますが、これらは免許を持つ医療従事者による診療に代わるものではありません。医学的な助言、診断、または治療については、必ず資格を持つ医療提供者にご相談ください。",
    "trustBanner": {
      "title": "HealthLoopはあなたのウェルネスの旅をサポートします",
      "description": "信頼できる情報源に基づき、一般的な健康教育と予防のガイダンスを提供します。これは専門的な医学的アドバイスではありません。医療に関する決定は、必ず資格を持つ医療提供者にご相談ください。"
    }
  },
  "health": {
    "preventiveHealth": "予防ヘルス・トラッカー",
    "educationHub": "エデュケーション・ハブ",
    "engagementWidget": "エンゲージメント・ウィジェット",
    "wellnessCheckIn": "ウェルネス・チェックイン",
    "todaysMetrics": "今日の数値",
    "bloodPressure": "血圧",
    "heartRate": "心拍数",
    "weight": "体重",
    "sleep": "睡眠",
    "waterIntake": "水分補給",
    "exercise": "運動",
    "logMetric": "数値を記録する",
    "viewHistory": "履歴を見る"
  },
  "aiInsights": {
    "title": "AI健康インサイト",
    "comingSoon": "インサイトを収集中です",
    "comingSoonDesc": "数日間チェックインを完了すると、あなたに合わせた穏やかなインサイトがここに表示されます。",
    "learnMore": "詳細を見る",
    "evidenceSources": {
      "WHO": "WHO（世界保健機関）のガイドラインに基づく",
      "NHS": "NHSの推奨に準拠",
      "CDC": "CDCのガイドラインにより裏付け",
      "RESEARCH": "査読済み研究に基づく",
      "CLINICAL": "臨床研究に基づく"
    }
  },
  "dailyInsight": {
    "title": "今日の健康インサイト",
    "gettingStarted": "はじめに",
    "focus": "注力ポイント",
    "quickInsight": "クイック・インサイト",
    "simpleExplanation": "わかりやすい解説",
    "realLifeImpact": "生活への影響",
    "yourActionStep": "最初の一歩",
    "basedOnYour": "これまでの傾向に基づく：",
    "personalizedFor": "最近の健康データに基づき、あなたに合わせてパーソナライズされています",
    "getNewInsight": "新しいインサイトを取得",
    "newInsightLoaded": "新しいインサイトを読み込みました！ 💡",
    "failedToRefresh": "インサイトの更新に失敗しました",
    "priority": {
      "high": "ここを意識しましょう",
      "medium": "注目すべきポイント"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "現在、注意が必要な項目はありません",
    "noAlertsDesc": "健康的な習慣を維持できています。その調子です！",
    "whatYouCanDo": "おすすめのアクション：",
    "viewMealSuggestions": "おすすめのメニュー提案を見る"
  },
  "engagement": {
    "currentStreak": "現在の継続日数",
    "bestStreak": "自己ベスト",
    "thisWeek": "今週",
    "exerciseDays": "運動した日",
    "hydrationDays": "水分補給した日",
    "healthMetricsLogged": "記録した数値",
    "weeklyGoalsProgress": "週間の目標達成度",
    "completed": "完了",
    "days": "日間",
    "keepGoing": "その調子です！",
    "personalRecord": "自己ベスト更新！",
    "goalMet": "目標達成！"
  },
  "reminders": {
    "title": "健康リマインダー",
    "subtitle": "あなたに合わせた通知で習慣を維持しましょう",
    "breakfast": "朝食のリマインダー",
    "lunch": "昼食のリマインダー",
    "dinner": "夕食のリマインダー",
    "water": "水分補給",
    "movement": "軽い運動の休憩",
    "sleep": "就寝のリマインダー",
    "wellness": "ウェルネス・チェックイン",
    "healthLogging": "健康状態の記録",
    "annualCheckup": "定期健診",
    "enable": "有効",
    "disable": "無効",
    "customize": "時間を設定する",
    "stayConsistent": "スマート・リマインダーで継続をサポート",
    "setupFriendly": "健康的な習慣づくりを助ける、優しい通知を設定しましょう。",
    "customizeWhen": "通知の時間や頻度は自由にカスタマイズ可能です。",
    "supportive": "通知は生活の邪魔にならないよう、優しくお届けします。 💚",
    "noPreferences": "設定が見つかりません",
    "noPreferencesDesc": "設定の読み込みに失敗しました。初めてのご利用か、一時的な通信エラーの可能性があります。",
    "retryLoading": "再試込み",
    "saveSettings": "設定を保存する",
    "saving": "保存中..."
  },
  "empty": {
    "startJourney": "ウェルネスの旅を始めましょう",
    "startJourneyDesc": "今日から健康への一歩を踏み出しませんか？今の気分を共有して、パーソナライズされたインサイトを受け取りましょう。",
    "completeFirstCheckIn": "最初のチェックインを行う",
    "stayOnTrack": "習慣を維持する",
    "stayOnTrackDesc": "日々のルーチンを大切にしましょう 💊 お薬を登録すると、優しいリマインダーとサポートを受け取れます。",
    "addFirstMedication": "最初のお薬を追加する",
    "learnMedicationSafety": "お薬の安全性について学ぶ",
    "buildMealLibrary": "お気に入りメニューを増やしましょう",
    "buildMealLibraryDesc": "お気に入りのメニューがまだありません。好きな食事を保存して、メニュー選びを簡単にしましょう。",
    "exploreMealOptions": "メニューを探す",
    "insightsAwait": "あなたへのインサイトをご用意します",
    "insightsAwaitDesc": "日々のチェックインを完了し、ウェルネスを記録することで、あなたに合わせた健康パターン分析が利用可能になります。",
    "startDailyCheckIn": "今日のチェックインを始める",
    "learnAboutInsights": "インサイトについて詳しく",
    "buildingStory": "あなたのウェルネス・ストーリー",
    "buildingStoryDesc": "データがまだありません。日々のチェックインを続けると、ここに健康のトレンドやパターンが表示されます。",
    "completeCheckIn": "チェックインを完了する",
    "tipComplete7Days": "ヒント：7日間チェックインを続けると、より意味のある傾向が見えてきます。",
    "startTrackingHabits": "健康習慣の記録を始める",
    "startTrackingHabitsDesc": "記録された習慣はまだありません。毎日の小さな積み重ねが、持続的な健康へと繋がります。",
    "trackFirstHabit": "最初の習慣を記録する",
    "getMoving": "体を動かしましょう",
    "getMovingDesc": "活動記録がありません。10分間の運動でも、気分やエネルギーを高める効果があります。",
    "logActivity": "活動を記録する",
    "allCaughtUp": "すべて確認済みです！",
    "allCaughtUpDesc": "新しい通知はありません。また後でウェルネス・リマインダーをチェックしてください。",
    "noResultsFound": "結果が見つかりませんでした",
    "noResultsFoundDesc": "「{query}」に一致する結果はありませんでした。検索条件を変えるか、他のオプションを探してみてください。"
  },
  "footer": {
    "tagline": "AIが支えるあなたの予防医療コンパニオン",
    "builtWith": "あなたのウェルネスな毎日のために、心を込めて",
    "allRightsReserved": "All rights reserved.",
    "about": "HealthLoopについて",
    "privacy": "プライバシーポリシー",
    "terms": "利用規約",
    "contact": "お問い合わせ",
    "helpCenter": "ヘルプセンター"
  },
  "modals": {
    "feedback": {
      "title": "フィードバックをお寄せください",
      "subtitle": "HealthLoopの改善にご協力をお願いします",
      "whatWorking": "良かった点はありますか？",
      "whatImprove": "改善すべき点はありますか？",
      "placeholder": "あなたのご意見をお聞かせください...",
      "thankYou": "フィードバックありがとうございます！",
      "submitted": "いただいたご意見は、HealthLoopの向上に役立てさせていただきます。"
    },
    "reportProblem": {
      "title": "問題を報告する",
      "subtitle": "不具合の修正とアプリの改善にご協力ください",
      "describe": "問題の内容",
      "placeholder": "何が起きましたか？できるだけ詳しく教えてください...",
      "optional": "（任意）再現手順",
      "stepsPlaceholder": "1. 〇〇をクリックした\n2. 次に〇〇をした...",
      "thankYou": "ご報告ありがとうございます！",
      "submitted": "早急に内容を確認させていただきます。"
    },
    "mealPreferences": {
      "title": "食事設定のカスタマイズ",
      "subtitle": "あなたの食の好みについて教えてください",
      "cuisines": "お好みの料理",
      "selectCuisines": "当てはまるものをすべて選択してください",
      "dietary": "食事制限・志向",
      "selectDietary": "食事に関するニーズを選択してください",
      "allergies": "アレルギー・制限事項",
      "allergiesPlaceholder": "例：ナッツ類、甲殻類、グルテンなど",
      "save": "設定を保存",
      "saving": "保存中..."
    },
    "upgrade": {
      "title": "プレミアムプランへアップグレード",
      "subtitle": "すべての機能を利用可能にする",
      "features": "プレミアム限定機能",
      "getStarted": "今すぐ始める",
      "learnMore": "詳細を見る"
    }
  },
  "login": {
    "title": "予防医療インテリジェンス・プラットフォーム",
    "subtitle": "問題が深刻化する前に、記録、学習、そして行動を。予防、教育、継続、ウェルネスのために設計されています。",
    "email": "メールアドレス",
    "password": "パスワード",
    "signIn": "サインイン",
    "signingIn": "サインイン中...",
    "forgotPassword": "パスワードをお忘れですか？",
    "noAccount": "アカウントをお持ちでない場合",
    "createAccount": "新規作成",
    "biometricLogin": "生体認証でサインイン",
    "biometricHelper": "指紋認証、Face ID、またはWindows Helloを使用",
    "authenticating": "認証中...",
    "vendorPartner": "パートナー企業の方はこちら",
    "vendorLogin": "ベンダーログイン",
    "emailRequired": "まずメールアドレスを入力してください",
    "biometricSuccess": "生体認証でサインインしました！ 🎉",
    "noPasskeys": "生体認証が設定されていません。まずはパスワードでサインインしてください。",
    "biometricCancelled": "生体認証がキャンセルされました",
    "biometricFailed": "生体認証に失敗しました。パスワードでサインインしてください。"
  },
  "register": {
    "title": "HealthLoopへようこそ",
    "subtitle": "今日から予防医療の習慣を始めましょう",
    "fullName": "氏名",
    "email": "メールアドレス",
    "password": "パスワード",
    "confirmPassword": "パスワード（確認用）",
    "createAccount": "アカウントを作成",
    "haveAccount": "すでにアカウントをお持ちですか？",
    "signIn": "サインイン",
    "creating": "アカウント作成中...",
    "passwordTooShort": "パスワードは8文字以上で設定してください",
    "setupBiometric": "生体認証の設定",
    "setupBiometricDesc": "指紋認証やFace IDを使用して、より速く、安全にサインインできます",
    "setupNow": "今すぐ設定する",
    "skipForNow": "後で設定する",
    "settingUp": "設定中...",
    "benefit1": "パスワードを覚える必要がありません",
    "benefit2": "生体認証による高いセキュリティ",
    "benefit3": "ワンタップや顔認証で即座にサインイン",
    "biometricPrivacy": "生体データがデバイスの外へ送信されることはありません",
    "biometricSuccess": "生体認証の設定が完了しました！ 🎉",
    "biometricFailed": "生体認証の設定に失敗しました。後ほど設定画面からやり直せます。",
    "biometricSetupLater": "生体認証は、後でプロフィール設定から有効にできます"
  },
  "womensHealthPage": {
    "title": "ウィメンズヘルス・トラッカー",
    "subtitle": "周期、症状、ウェルネスの記録",
    "cycleOverview": "周期の概要",
    "currentPhase": "現在のフェーズ",
    "nextPeriod": "次回の予定日",
    "logPeriod": "生理を記録",
    "logSymptoms": "症状を記録",
    "insights": "周期のインサイト",
    "tips": "フェーズ別アドバイス",
    "history": "過去の記録",
    "noData": "記録がまだありません",
    "noDataDesc": "記録を始めると、あなたに合わせた分析や予測が表示されます。",
    "startTracking": "記録を始める"
  },
  "notifications": {
    "title": "通知",
    "markAllRead": "すべて既読にする",
    "noNotifications": "新しい通知はありません",
    "viewAll": "すべて見る"
  },
  "familyHealth": {
    "title": "ファミリー＆チャイルドケア",
    "subtitle": "家族全員の予防医療をサポート",
    "tabImmunizations": "予防接種",
    "tabEducation": "お役立ち情報",
    "tabReminders": "リマインダー",
    "tabPlanner": "ファミリープランナー",
    "immunizations": {
      "title": "予防接種ガイド",
      "subtitle": "推奨されるワクチン情報を確認しましょう",
      "recommendedSchedule": "推奨スケジュール",
      "byAge": "年齢別",
      "infants": "乳児（0-12ヶ月）",
      "toddlers": "幼児（1-3歳）",
      "preschool": "未就学児（4-6歳）",
      "schoolAge": "学童期（7-12歳）",
      "teens": "思春期（13-18歳）",
      "adults": "成人",
      "learnMore": "詳細を見る",
      "consultDoctor": "具体的な接種については、必ずかかりつけの医師にご相談ください",
      "upcomingReminders": "今後の接種予定",
      "noReminders": "予定されている接種はありません",
      "addReminder": "予定を追加",
      "reminderFor": "対象者",
      "dueDate": "予定日",
      "notes": "メモ",
      "markComplete": "完了にする"
    },
    "education": {
      "title": "家族の健康ガイド",
      "subtitle": "根拠に基づいた予防医療の情報",
      "categories": "カテゴリー",
      "infant": "乳児のケア",
      "child": "子供の発達",
      "nutrition": "栄養と成長",
      "safety": "安全と事故防止",
      "mental": "こころの健康",
      "hygiene": "衛生と習慣",
      "searchPlaceholder": "健康トピックを検索...",
      "popularTopics": "人気のトピック",
      "readMore": "続きを読む",
      "readTime": "分で読めます"
    },
    "reminders": {
      "title": "家族の健康リマインダー",
      "subtitle": "家族の予防ケアを忘れずに管理しましょう",
      "createReminder": "リマインダー作成",
      "familyMember": "家族の名前",
      "reminderType": "項目の種類",
      "frequency": "頻度",
      "activeReminders": "設定中のリマインダー",
      "upcomingThisWeek": "今週の予定",
      "noActiveReminders": "設定されているリマインダーはありません",
      "types": {
        "checkup": "健康診断",
        "dental": "歯科検診",
        "vision": "眼科検診",
        "vaccine": "予防接種",
        "medication": "お薬",
        "custom": "カスタム"
      }
    },
    "planner": {
      "title": "ファミリーヘルス・プランナー",
      "subtitle": "家族の予防ケアをまとめて管理",
      "addMember": "家族を追加",
      "memberName": "お名前",
      "relationship": "続柄",
      "dateOfBirth": "生年月日",
      "viewCalendar": "カレンダーを見る",
      "upcomingCare": "今後の予防ケア予定",
      "nothingScheduled": "予定はまだありません",
      "scheduleCheckup": "健診を予約・登録",
      "relationships": {
        "child": "子供",
        "spouse": "配偶者",
        "parent": "親",
        "sibling": "兄弟・姉妹",
        "other": "その他"
      }
    },
    "content": {
      "infantCare": {
        "title": "乳児の予防ケア",
        "intro": "生後1年間に大切な予防医療の習慣",
        "topics": [
          "乳幼児健診のスケジュール",
          "発達の目安とチェックポイント",
          "安全な睡眠環境",
          "栄養と授乳・離乳食",
          "予防接種の進め方"
        ]
      },
      "childDevelopment": {
        "title": "子供の発達と成長の目安",
        "intro": "健やかな成長と発達を理解するために",
        "topics": [
          "身体機能の発達",
          "社会性と情緒の育ち",
          "言葉の発達",
          "認知機能のステップ",
          "専門家に相談するタイミング"
        ]
      },
      "nutrition": {
        "title": "栄養と健やかな成長",
        "intro": "幼少期からの健康な食習慣づくり",
        "topics": [
          "年齢に応じた栄養素",
          "ヘルシーなおやつのアイデア",
          "好き嫌いへの対応方法",
          "食中毒予防の基本",
          "水分補給のガイドライン"
        ]
      },
      "safety": {
        "title": "安全と怪我の防止",
        "intro": "家族のための安全な環境づくり",
        "topics": [
          "家庭内安全チェックリスト",
          "チャイルドシートの安全使用",
          "水辺の事故防止",
          "誤飲・中毒の予防",
          "緊急時の備え"
        ]
      }
    }
  }
};
